(function() {
  var API_URL = window.TGL_API_URL || '';
  var root = document.getElementById('travel-guides-landing');

  // ── Search & Filter ──
  var searchInput = document.getElementById('tgl-search-input');
  var searchClear = document.getElementById('tgl-search-clear');
  var grid = document.getElementById('tgl-grid');
  var emptyEl = document.getElementById('tgl-empty');
  var emptyTerm = document.getElementById('tgl-empty-term');
  var countEl = document.getElementById('tgl-count');
  var items = grid ? Array.from(grid.querySelectorAll('.tgl-card-wrap')) : [];
  var activeRegion = 'all';
  var searchTerm = '';
  var currentPage = 1;
  var perPage = 9;
  var paginationEl = document.getElementById('tgl-pagination');

  function applyFilters() {
    // Collect matching items
    var matched = [];
    items.forEach(function(item) {
      var name = item.dataset.name || '';
      var tags = item.dataset.tags || '';
      var region = item.dataset.region || '';
      var matchSearch = !searchTerm || name.indexOf(searchTerm) >= 0 || tags.indexOf(searchTerm) >= 0;
      var matchRegion = activeRegion === 'all' || region === activeRegion;
      if (matchSearch && matchRegion) matched.push(item);
    });

    var totalPages = Math.ceil(matched.length / perPage);
    if (currentPage > totalPages) currentPage = 1;
    var start = (currentPage - 1) * perPage;
    var end = start + perPage;

    // Hide all, show only current page
    items.forEach(function(item) { item.classList.add('tgl-card--hidden'); });
    matched.forEach(function(item, i) {
      if (i >= start && i < end) item.classList.remove('tgl-card--hidden');
    });

    if (countEl) countEl.textContent = matched.length + ' guide' + (matched.length !== 1 ? 's' : '');
    if (emptyEl) {
      emptyEl.style.display = matched.length === 0 ? '' : 'none';
      if (emptyTerm) emptyTerm.textContent = searchTerm;
    }
    if (searchClear) searchClear.style.display = searchTerm ? '' : 'none';

    renderPagination(totalPages);
  }

  function renderPagination(totalPages) {
    if (!paginationEl) return;
    if (totalPages <= 1) { paginationEl.innerHTML = ''; return; }

    var html = '<nav class="pagination" role="navigation" aria-label="Pagination">';

    // Previous
    html += '<div class="' + (currentPage <= 1 ? 'pagination__button-disabled' : '') + '">';
    html += '<a href="#" class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce" data-page="' + (currentPage - 1) + '">';
    html += '<span class="svg-wrapper"><svg class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/></svg></span>';
    html += '<span class="pagination__label">' + (root.dataset.tPrevious || 'Previous') + '</span></a></div>';

    // Page numbers
    html += '<ul class="pagination__list list-unstyled" role="list">';
    var pages = getPaginationPages(currentPage, totalPages);
    pages.forEach(function(p) {
      if (p === '...') {
        html += '<li><span class="pagination__item">\u2026</span></li>';
      } else if (p === currentPage) {
        html += '<li><a role="link" aria-disabled="true" class="pagination__item pagination__item--current" aria-current="page">' + p + '</a></li>';
      } else {
        html += '<li><a href="#" class="pagination__item link" data-page="' + p + '">' + p + '</a></li>';
      }
    });
    html += '</ul>';

    // Next
    if (currentPage < totalPages) {
      html += '<div><a href="#" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce" data-page="' + (currentPage + 1) + '">';
      html += '<span class="pagination__label">' + (root.dataset.tNext || 'Next') + '</span>';
      html += '<span class="svg-wrapper"><svg class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/></svg></span>';
      html += '</a></div>';
    }

    html += '</nav>';
    paginationEl.innerHTML = html;

    // Bind clicks
    paginationEl.querySelectorAll('[data-page]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var page = parseInt(link.dataset.page);
        if (page >= 1 && page <= totalPages) {
          currentPage = page;
          applyFilters();
          grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  function getPaginationPages(current, total) {
    if (total <= 5) {
      var arr = [];
      for (var i = 1; i <= total; i++) arr.push(i);
      return arr;
    }
    var pages = [1];
    if (current > 3) pages.push('...');
    for (var i = Math.max(2, current - 1); i <= Math.min(total - 1, current + 1); i++) {
      pages.push(i);
    }
    if (current < total - 2) pages.push('...');
    pages.push(total);
    return pages;
  }

  if (searchInput) {
    searchInput.addEventListener('input', function() {
      searchTerm = searchInput.value.trim().toLowerCase();
      currentPage = 1;
      applyFilters();
    });
    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }
  if (searchClear) {
    searchClear.addEventListener('click', function() {
      searchInput.value = ''; searchTerm = ''; currentPage = 1; applyFilters(); searchInput.focus();
    });
  }
  document.querySelectorAll('.tgl-pill').forEach(function(pill) {
    pill.addEventListener('click', function() {
      document.querySelectorAll('.tgl-pill').forEach(function(p) { p.classList.remove('tgl-pill--active'); });
      pill.classList.add('tgl-pill--active');
      activeRegion = pill.dataset.region;
      currentPage = 1;
      applyFilters();
    });
  });
  applyFilters();

  // ── Trip Planner (reuses tg-* IDs from travel-guide.js pattern) ──
  if (!window.TGL_DESTINATION_MODE) return;

  var style = '';
  var interests = [];
  var setupEl = document.getElementById('tg-planner-setup');
  var chatEl = document.getElementById('tg-planner-chat');
  var messagesEl = document.getElementById('tg-chat-messages');
  var generateBtn = document.getElementById('tg-generate-btn');
  var destinationInput = document.getElementById('tgl-destination');
  var dateStart = document.getElementById('tg-date-start');
  var dateEnd = document.getElementById('tg-date-end');
  var daysBadge = document.getElementById('tg-days-badge');

  function getDays() {
    if (!dateStart || !dateStart.value || !dateEnd || !dateEnd.value) return 0;
    return Math.max(1, Math.ceil((new Date(dateEnd.value) - new Date(dateStart.value)) / 86400000) + 1);
  }

  function checkReady() {
    var dest = destinationInput ? destinationInput.value.trim() : '';
    if (generateBtn) generateBtn.disabled = !(dest && dateStart.value && dateEnd.value && style && interests.length > 0);
    var d = getDays();
    if (daysBadge) {
      if (d > 0) { daysBadge.textContent = d + ' day' + (d !== 1 ? 's' : ''); daysBadge.style.display = ''; }
      else daysBadge.style.display = 'none';
    }
  }

  if (destinationInput) destinationInput.addEventListener('input', checkReady);
  if (dateStart) dateStart.addEventListener('change', checkReady);
  if (dateEnd) dateEnd.addEventListener('change', checkReady);

  // Open the native date picker when clicking anywhere on the field, not just
  // the small calendar icon (desktop Chrome/Edge only expand on the icon).
  function openDatePicker() {
    if (typeof this.showPicker === 'function') {
      try { this.showPicker(); } catch (e) {}
    }
  }
  if (dateStart) dateStart.addEventListener('click', openDatePicker);
  if (dateEnd) dateEnd.addEventListener('click', openDatePicker);

  // No past dates, and the departing date can't be before the arriving date.
  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  var todayStr = (function() {
    var d = new Date();
    return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate());
  })();
  if (dateStart) dateStart.min = todayStr;
  if (dateEnd) dateEnd.min = todayStr;
  if (dateStart) dateStart.addEventListener('change', function() {
    var min = dateStart.value || todayStr;
    if (dateEnd) {
      dateEnd.min = min;
      if (dateEnd.value && dateEnd.value < min) dateEnd.value = '';
    }
    checkReady();
  });

  document.querySelectorAll('#tg-style-chips .tg-chip').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('#tg-style-chips .tg-chip').forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active'); style = btn.dataset.value; checkReady();
    });
  });

  document.querySelectorAll('#tg-interest-chips .tg-chip').forEach(function(btn) {
    btn.addEventListener('click', function() {
      btn.classList.toggle('active');
      if (btn.classList.contains('active')) interests.push(btn.dataset.value);
      else interests = interests.filter(function(i) { return i !== btn.dataset.value; });
      checkReady();
    });
  });

  function addMessage(role, content) {
    var div = document.createElement('div');
    div.className = 'tg-msg tg-msg--' + role;
    // API returns HTML in JSON — render directly
    var html = role === 'assistant' ? content : content.replace(/\n/g,'<br>');
    div.innerHTML = role === 'assistant'
      ? '<div class="tg-msg__avatar"><i class="ph ph-airplane-tilt"></i></div><div class="tg-msg__bubble">' + html + '</div>'
      : '<div class="tg-msg__bubble">' + html + '</div>';
    messagesEl.appendChild(div);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function showLoading() {
    var div = document.createElement('div');
    div.className = 'tg-msg tg-msg--assistant'; div.id = 'tg-loading';
    div.innerHTML = '<div class="tg-msg__avatar"><i class="ph ph-airplane-tilt"></i></div><div class="tg-msg__bubble"><span class="tg-typing"><span></span><span></span><span></span></span></div>';
    messagesEl.appendChild(div); messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function hideLoading() { var el = document.getElementById('tg-loading'); if (el) el.remove(); }

  function callAI(prompt, country) {
    return fetch(API_URL, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ prompt: prompt, country: country })
    }).then(function(r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function(d) { return d.response || 'Could not generate. Try again.'; })
      .catch(function() { return 'The AI planner is warming up. Please try again in a moment.'; });
  }

  if (generateBtn) {
    generateBtn.addEventListener('click', function() {
      var dest = destinationInput.value.trim();
      var days = getDays();
      setupEl.style.display = 'none';
      chatEl.style.display = '';
      setTimeout(function() { chatEl.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 100);
      showLoading();
      var fmtDate = function(val) {
        var d = new Date(val + 'T00:00:00');
        return d.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'short', year: 'numeric' });
      };
      var prompt = 'You are a friendly travel expert. Start your response with one warm, enthusiastic sentence welcoming the traveller to ' + dest + ' and expressing excitement about their trip. Then provide a full ' + days + '-day itinerary from ' + fmtDate(dateStart.value) + ' to ' + fmtDate(dateEnd.value) + '. Label each day as "Day 1: ' + fmtDate(dateStart.value).replace(/\w+, /, '') + '" etc. using the actual date in that format. Travel style: ' + style + '. Interests: ' + interests.join(', ') + '. Structure each day with morning, afternoon, and evening activities, specific restaurant recommendations, transport tips, and one insider tip. Use real place names. End with a short packing checklist.';
      callAI(prompt, dest).then(function(response) {
        hideLoading();
        addMessage('assistant', response);
        var emailCapture = document.getElementById('tg-email-capture');
        if (emailCapture) emailCapture.style.display = '';
      });
    });
  }

  var chatInput = document.getElementById('tg-chat-input');
  var chatSend = document.getElementById('tg-chat-send');
  function sendChat() {
    var msg = chatInput.value.trim(); if (!msg) return;
    var dest = destinationInput ? destinationInput.value.trim() : '';
    chatInput.value = ''; addMessage('user', msg); showLoading();
    callAI('Context: planning a trip to ' + (dest || 'the destination') + '.\nUser: ' + msg, dest)
      .then(function(r) { hideLoading(); addMessage('assistant', r); });
  }
  if (chatSend) chatSend.addEventListener('click', sendChat);
  if (chatInput) chatInput.addEventListener('keydown', function(e) { if (e.key === 'Enter') sendChat(); });

  // Register the visitor as a Shopify customer / email subscriber via the
  // native customer form endpoint, so they appear under Customers in the admin.
  // This is independent of the itinerary-email backend (fire-and-forget).
  function subscribeToShopifyList(email, firstName, lastName) {
    try {
      // Preferred: submit the native Shopify customer form into a hidden iframe.
      // It's a genuine form POST (correct action + hidden fields) so Shopify
      // reliably creates the subscriber, while the iframe keeps the visitor on
      // the itinerary instead of navigating away.
      var form = document.getElementById('tg-subscribe-form');
      if (form) {
        var field = document.getElementById('tg-subscribe-email');
        if (field) field.value = email;
        var firstField = document.getElementById('tg-subscribe-firstname');
        if (firstField) firstField.value = firstName || '';
        var lastField = document.getElementById('tg-subscribe-lastname');
        if (lastField) lastField.value = lastName || '';
        form.target = 'tg-subscribe-sink';
        // Submit with requestSubmit() (NOT submit()) so a real "submit" event
        // fires. That event is what lets Shopify's spam-protection/captcha attach
        // its token, exactly like the footer newsletter's button click. A bare
        // form.submit() skips the event, so Shopify silently drops the POST and no
        // customer is ever created. Fall back to submit() on very old browsers.
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
        return;
      }
      // Fallback for any context that doesn't render the form.
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var body = 'form_type=customer&utf8=%E2%9C%93'
        + '&contact[email]=' + encodeURIComponent(email)
        + '&contact[first_name]=' + encodeURIComponent(firstName || '')
        + '&contact[last_name]=' + encodeURIComponent(lastName || '')
        + '&contact[tags]=' + encodeURIComponent('newsletter,trip-planner');
      fetch(base + 'contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body
      }).catch(function() {});
    } catch (e) {}
  }

  // Email send handler
  var emailSendBtn = document.getElementById('tg-email-send');
  if (emailSendBtn) {
    emailSendBtn.addEventListener('click', function() {
      var firstNameEl = document.getElementById('tg-firstname-input');
      var lastNameEl = document.getElementById('tg-lastname-input');
      var firstName = firstNameEl ? firstNameEl.value.trim() : '';
      var lastName = lastNameEl ? lastNameEl.value.trim() : '';
      var email = document.getElementById('tg-email-input').value.trim();
      var marketingOptin = document.getElementById('tg-marketing-optin').checked;
      // Email is the ONLY hard requirement — the itinerary send must never be
      // blocked by the optional name capture.
      if (email.indexOf('@') === -1) { document.getElementById('tg-email-input').focus(); return; }
      // Ask for a first name when the field is on the page, but never require a
      // last name and never block when the fields aren't rendered.
      if (firstNameEl && !firstName) { firstNameEl.focus(); return; }
      var name = (firstName + ' ' + lastName).trim();
      // Add to the Shopify subscribers list when the opt-in box is ticked.
      if (marketingOptin) subscribeToShopifyList(email, firstName, lastName);
      var originalText = emailSendBtn.innerHTML;
      emailSendBtn.disabled = true;
      emailSendBtn.innerHTML = 'Sending...';
      var msgs = messagesEl.querySelectorAll('.tg-msg--assistant .tg-msg__bubble');
      var itinerary = msgs.length > 0 ? msgs[0].innerHTML : '';
      var dest = destinationInput ? destinationInput.value.trim() : '';
      // Abort after 20s so a slow/unresponsive API can never leave the button stuck on "Sending..."
      var controller = new AbortController();
      var timeoutId = setTimeout(function() { controller.abort(); }, 20000);
      fetch(API_URL.replace('/trip-plan', '/send-itinerary'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        signal: controller.signal,
        body: JSON.stringify({
          email: email, name: name, firstName: firstName, lastName: lastName,
          country: dest, countrySlug: dest.toLowerCase().replace(/\s+/g,'-'),
          itinerary: itinerary, marketingOptin: marketingOptin
        })
      }).then(function(res) {
        clearTimeout(timeoutId);
        if (!res.ok) throw new Error('Failed');
        document.getElementById('tg-email-capture').style.display = 'none';
        document.getElementById('tg-email-sent').style.display = '';
      }).catch(function() {
        clearTimeout(timeoutId);
        emailSendBtn.disabled = false;
        emailSendBtn.innerHTML = originalText;
        alert('Failed to send email. Please try again.');
      });
    });
  }

  // FAQ accordion (same as travel-guide.js)
  document.querySelectorAll('.travel-guide .faqs__question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var answer = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', String(!expanded));
      if (answer) answer.setAttribute('aria-hidden', String(expanded));
    });
  });
})();
